import { EntityMultiSelect, Form } from '@domain-group/suit-theme'

import useAgencyProvider from '@hooks/useAgencyProvider'
import useProviderPackages from '@hooks/useProviderPackages'

import EntitySelector from '@components/EntitySelector'

import useBulkCreateAgencyProviderPackagesModal from '../../hooks/useBulkCreateAgencyProviderPackagesModal'

type SelectPackagesProps = {
  agencyId: number,
  bulkCreateAgencyProviderPackagesPayload: ReturnType<typeof useBulkCreateAgencyProviderPackagesModal>,
  isTopModal: boolean,
}

const SelectPackages = (props: SelectPackagesProps) => {
  const { agencyId, bulkCreateAgencyProviderPackagesPayload, isTopModal } = props

  const {
    providerPackages,
    callbacks: {
      setSelectedEntityIds,
    },
    debouncedString,
    selectedEntityIds,
    searchForm,
  } = bulkCreateAgencyProviderPackagesPayload

  const {
    entityState: {
      provider_id, string,
    },
    setEntityState: setSearchState,
  } = searchForm

  const packagesPayload = useProviderPackages({
    filters: {
      provider_id,
      string: debouncedString,
    },
    performHttpRequests: debouncedString ? debouncedString.length > 1 : true,
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredProviderPackages,
    filteredProviderPackagesCount,
    loading,
  } = packagesPayload

  const {
    callbacks: { createOrEditAgencyProvider },
  } = useAgencyProvider({ agency_id: agencyId })

  const filteredProviderPackagesIds = filteredProviderPackages.map(provider_package => provider_package.id)

  return (
    <>
      <EntitySelector
        callbacks={{
          selectItem: provider => setSearchState({ provider_id: provider ? provider.id : null }),
        }}
        entityKey="providers"
        label="* Provider"
        searchForwardProps={{
          listAction: (
            // @ts-expect-error TS2741
            <EntitySelector.CreateEntity
              onClick={() => createOrEditAgencyProvider()}
              strings={{ create: 'Assign' }}
            />
          ),
        }}
        shouldRefetch={isTopModal}
        searchRequestOptions={{ assigned_agency_id: agencyId }}
        selectedItemId={provider_id}
      />

      <Form.Field label="Package Title" marginTop="large">
        <input onChange={e => setSearchState({ string: e.target.value })} value={string} />
      </Form.Field>

      {(provider_id || !!selectedEntityIds.length) && (
        // @ts-expect-error TS2741
        <EntityMultiSelect
          boxProps={{ marginTop: 'large' }}
          callbacks={{
            loadMore,
            setSelectedIds: setSelectedEntityIds,
          }}
          canLoadMore={canLoadMore}
          entities={providerPackages}
          entityCount={provider_id ? filteredProviderPackagesCount : 0}
          filteredEntityIds={provider_id ? filteredProviderPackagesIds : []}
          loading={loading}
          selectedIds={selectedEntityIds}
        />
      )}
    </>
  )
}

export default SelectPackages
